import React from "react";
import { withRouter } from "react-router-dom";
import { compose } from "react-apollo";
import { withStore } from "../../store";
import Tile from "../Tile/Tile";
import PersonTile from "../Tile/PersonTile";
import { Button } from "@brightcove/studio-components";
import classnames from "classnames";
import ExternalLink from "../ExternalLink/ExternalLink";
import { toggleAccordion, getPageType, fetchHandler, getClientApiURL } from "../../utils";
import "./Grid.scss";
import { metUrl } from "../../config/metMainSite";

class Grid extends React.Component<any, any> {

  static defaultProps = {
    pageSize: 3
  }

  constructor(props) {
    super(props);
    this.state = {
      visible : this.props.pageSize,
      expandGrid: this.props.expandGrid,
      showTrial: Boolean(this.props.showTrialCta)
    };
  }

  componentDidMount(): void {
    if (!this.props.showTrialCta) {
      return;
    }

    const url = `${getClientApiURL(`/authorization?reference_id=audio_stream`)}`;
    const options = {
      method: "GET",
    };

    fetchHandler(url, options, () => {
      this.setState({ showTrial: false });
    }, () => {
      this.setState({ showTrial: true });
    });
  }

  toggleGrid = () => {
    this.setState((prev) => {
      return {expandGrid: !prev.expandGrid};
    });
    this.props.onExpandGrid && this.props.onExpandGrid(this.props.header, this.state.expandGrid);
  }

  loadMore = () => {
    this.setState((prev) => {
      return {visible: prev.visible + this.props.pageSize};
    });
  }


  render() {
    const { tiles, header, videoCount, audioCount, pageSize, showPagination, showTrialCta } = this.props;
    const { expandGrid, visible, showTrial } = this.state;
    const pageType = getPageType();
    const tilesToShow = showPagination ? tiles.slice(0, visible) : tiles;
    const isAccordion = typeof this.props.expandGrid !== "undefined";
    const isExpanded = isAccordion ? !!expandGrid : true;
    const className = classnames("Grid accordion", isAccordion ? "accordion-desktop" : "", typeof expandGrid !== "undefined" ? (expandGrid ? "expanded" : "collapsed") : "");
    // Stable id so the accordion button can reference the body via aria-controls
    const bodyId = `grid-body-${(header || "").toString().replace(/\s+/g, "-").toLowerCase()}-${tiles.length}`;

    return (
      <div className={className}>
        { header &&
          // MET2-2850: Grid accordion header was <div onClick> — switched to <button>
          // so it's tab-reachable + announces aria-expanded to assistive tech.
          <button
            type="button"
            className="Grid-header-wrapper"
            onClick={pageType === "performance" ? toggleAccordion : this.toggleGrid}
            aria-expanded={isExpanded}
            aria-controls={bodyId}
          >
            <div className="Grid-header">
              <h2>{header}<span className="Grid-items-count"> ({tiles.length})</span></h2>
              {isAccordion &&
                <p className="Grid-header-media-type-counts">
                  {typeof videoCount !== undefined && videoCount > 0 &&
                    <span><strong className="count">{videoCount}</strong> Video&nbsp;&nbsp;</span>
                  }
                  {typeof audioCount !== undefined && audioCount > 0 &&
                    <span><strong className="count">{audioCount}</strong> Audio</span>
                  }
                </p>
              }
            </div>
            <span className="Grid-header-accordion" aria-hidden="true"><span></span></span>
          </button>
        }
        <div className="Grid-contents" id={bodyId}>
          {
            tilesToShow.map((tile, index) => {
              return tile.roles ? <PersonTile key={index} {...tile} /> : <Tile key={index} {...tile} />
            })
          }
        </div>
        { (visible < tiles.length) && showPagination &&
          <Button look='tertiary' theme="classic" className="btn btn-clear btn-load-more" onClick={this.loadMore}>+ Load More ({pageSize})</Button>
        }
        { showTrialCta && showTrial &&
          <ExternalLink url={metUrl("/season/on-demand/learn-more")} style={{ textDecoration: "none", textAlign: "center", display: "block", marginTop: "2.5rem" }}>
            <button className="btn btn-pink Grid-trial-cta"><span>Start Free Trial</span></button>
          </ExternalLink>
        }
      </div>
    )
  }
};

export default compose(withRouter, withStore)(Grid);
